import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import PatientsFilesWithPatientsPage from 'model/PatientsFilesWithPatientsPage'

function mapDocument(document: any): any {
  const { _id, _rev, ...values } = document
  return {
    id: _id,
    rev: _rev,
    ...values,
  }
}

function PatientFileWithPatientMap(document: any): any {
  const { file, patient } = document
  if (file && patient) {
    return {
      file: mapDocument(file),
      patient: mapDocument(patient),
    }
  } else {
    return null
  }
}

export class PatientsFilesPagesRepository extends WebRepository<PatientsFilesWithPatientsPage> {
  constructor() {
    super(new Api('patients_files'))
  }

  async searchUnCategorizedPage(bookmark: string): Promise<PatientsFilesWithPatientsPage> {
    return super.aggregate(
      {
        withPatient: true,
        sort: {
          updatedAt: -1,
        },
        limit: 10,
        bookmark: bookmark,
      },
      PatientFileWithPatientMap,
    )
  }

  async getFilessWithPatients(selector: any): Promise<any> {
    return super.aggregate(
      {
        withPatient: true,
        selector,
      },
      PatientFileWithPatientMap,
    )
  }
}

export default new PatientsFilesPagesRepository()
